import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { BusinessPartnerStatus } from '../-constants';
import { BusinessPartnerTableFilterSchema } from '../-zod-schema';

// TERMINATEDステータスをデフォルトにした検索スキーマ
const TerminatedBusinessPartnerFilterSchema = BusinessPartnerTableFilterSchema.extend({
  businessPartnerStatus: z.nativeEnum(BusinessPartnerStatus).default(BusinessPartnerStatus.TERMINATED)
});
export const Route = createFileRoute('/_staff/business-partner/_list/terminated/')({
  validateSearch: zodValidator(TerminatedBusinessPartnerFilterSchema)
});